







































































































import { Component, Vue } from 'vue-property-decorator'
import Global from './global/index.vue'
import Repurchase from './repurchase/index.vue'
import Discount from './discount/index.vue'
import CustomProduct from './customProduct/index.vue'
import CustomDistributor from './customDistributor/index.vue'
import distributorApi from '@/api/distributor/index'
import { CreateDistributionSettingDto } from './model/index'
import EditorCustomize from '@/components/editorCustomize/index.vue'
import CouponSelect from "@/components/coupon-select/index.vue";
@Component({
  components: {
    Global,
    Repurchase,
    Discount,
    CustomProduct,
    CustomDistributor,
    EditorCustomize,
    CouponSelect
  }
})
export default class DistributorSetting extends Vue {
  form: CreateDistributionSettingDto = {
    conditionType: 0,
    consumption: null,
    isNeedReview: true,
    withdrawIsNeedReview: true,
    fullAmount: 0,
    frequency: 0,
    description: null,
    brokerageType: 0,
    pepercentConfig: { direct: 0, indirect: 0 },
    level: 1,
    coupons: []
  }

  ruleForm = {
    pepercent: [
      {
        required: true,
        validator: this.validate,
        message: '请输入分佣比例',
        trigger: 'blur'
      }
    ],
    fullAmount: [
      {
        required: true,
        validator: this.validate,
        message: '请输入可提现金额',
        trigger: 'blur'
      }
    ],
    frequency: [
      {
        required: true,
        validator: this.validate,
        message: '请输入提现频率天数',
        trigger: 'blur'
      }
    ],
    description: [
      {
        required: true,
        message: '请输入分销说明',
        trigger: 'blur'
      }
    ]
  }
  get brokerageType() {
    return this.form.brokerageType.toString()
  }
  get transcolums() {
    return [
      {
        title: "优惠券名称",
        key: "couponName"
      },
      {
        title: "数量",
        key: "quantity",
        width: 150,
        render: (h, params) => {
          return h("InputNumber", {
            props: {
              value: this.form.coupons[params.index] ? this.form.coupons[params.index].quantity : 0,
              min: 1
            },
            on: {
              "on-change": (event: number) => {
                this.form.coupons[params.index].quantity = event;
              }
            }
          });
        }
      },
      {
        title: "操作",
        key: "action",
        slot: "action",
        width: 150,
      }
    ]
  }
  tabClick(name) {
    this.form.brokerageType = parseInt(name)
    //切换tab 重新初始化 pepercentConfig
    switch (this.form.brokerageType) {
      case 0:
        this.form.pepercentConfig = { direct: 0, indirect: 0 }
        return
      case 1:
        return {}
      case 2:
        return {}
      case 3:
        this.form.pepercentConfig = {
          period: 0,
          pepercents: [{ direct: 0, indirect: 0 }],
          otherDirectPepercent: 0,
          otherIndirectPepercent: 0
        }
        return
      case 4:
        this.form.pepercentConfig = {
          items: [{ minDiscount: 0, maxDiscount: 0, direct: 0, indirect: 0 }]
        }
        return
      default:
        return {}
    }
  }
  editorChange(e) {
    this.form.description = e
  }
  validate(rule, value, callback) {
    if (value === null) {
      return callback(new Error('请输入'))
    }
    callback()
  }

  couponSelectChange(list) {
    this.form.coupons = this.form.coupons.concat(
      list.map(x => {
        let item = {
          couponId: x.id,
          couponName: x.name,
          couponType: x.couponType,
          couponTypeDisplayName: x.couponTypeDisplayName,
          validDate: x.validDate,
          discountValue: x.discountValue,
          quantity: 1
        };
        return item;
      })
    );
  }
   // 删除优惠券
   removeCoupon(index) {
    this.form.coupons.splice(index, 1)
  }

  created() {
    this.getDistributionSetting()
  }

  /**
   * 获取分销员设置
   */
  getDistributionSetting() {
    distributorApi.getDistributionSetting().then(res => {
      if (res.data) {
        if(!res.data.coupons) {
          res.data.coupons = []
        }
        this.form = res.data
      }
    })
  }

  isNumeric(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
  }

  submit() {
    let vm = this
    let form: any = vm.$refs.form
    if (this.form.conditionType === 1 && !this.isNumeric(this.form.consumption)) {
      this.$Notice.error({ desc: '请填写推广员门槛' })
      return
    }
    form.validate(valid => {
      if (valid) {
        let id = vm.$route.query['id'] ? vm.$route.query['id'].toString() : null
        distributorApi.updateDistributionSetting(vm.form).then(res => {
          this.$Notice.success({
            desc: '保存成功'
          })
        })
      }
    })
  }
}
